import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomBoard from "../../components/CustomBoard";
import { withRouter } from "react-router-dom";
import ActivateAccount from "./components/ActivateAccount";
import { connect } from "react-redux";
import * as selector from "../../../common/selectors";
import * as registrationSelector from "../../../common/selectors/registration";
import * as registrationAction from "../../../common/actions/registration";
import CustomToast from "../../components/CustomToast";
import LoadingOverlay from "../../components/LoadingOverlay";
import AuthManager from "../../../utils/AuthManager";

class Registration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nric: "",
      height: 0,
      customToastStatus: false,
      toastMessage: "",
      registrationAction: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate() {
    const {
      registrationReqStatus,
      registrationReqData,
      registrationReqLoading,
    } = this.props;
   
    if (
      this.state.registrationAction === true &&
      registrationReqLoading === false && registrationReqStatus === true
    ) {
      const StatusCode = registrationSelector.registrationStatusCode(
        registrationReqData
      );
      if (StatusCode === 1) {
        // this.setState({ customToastStatus: true });
        // this.setState({
        //   toastMessage: "You may have an existing account. Please proceed to log in.",
        // });
        // const clientMobileNo = registrationSelector.registrationGetMobileNumber(
        //   registrationReqData
        // );
         const { history } = this.props;
        // AuthManager.setClientMobileNo(clientMobileNo);
        // AuthManager.setNric(this.state.nric);
        
        history.push("/AccountExist");
       
      } else if (StatusCode === 2) {
        
        const clientMobileNo = registrationSelector.registrationGetMobileNumber(
          registrationReqData
        );
        const otpRefNo = registrationSelector.registrationReference_Number(
          registrationReqData
        );
        
        const { history } = this.props;
        AuthManager.setClientMobileNo(clientMobileNo);
        AuthManager.setNric(this.state.nric);
        AuthManager.setOtpReference(otpRefNo);
        history.push("/RegistrationOtp");
      } else if (StatusCode === 3) {
        
        // const clientMobileNo = registrationSelector.registrationGetMobileNumber(
        //   registrationReqData
        // );
        
        const { history } = this.props;
        //AuthManager.setClientMobileNo(clientMobileNo);
        AuthManager.setNric(this.state.nric);
        history.push("/MobileNoRequired");

      } else if (StatusCode === 4) {
        this.setState({ customToastStatus: true });
        this.setState({
          toastMessage: "Sorry, your request cannot be processed. Please WhatsApp our Customer Care at +65 6887 8777.",
        });
      } else if (StatusCode === 5) {
        this.setState({ customToastStatus: true });
        this.setState({
          toastMessage: "Invalid NRIC/FIN/Passport",
        });
      } else {
        this.setState({ customToastStatus: true });
        this.setState({
          toastMessage:
            "Sorry, your request cannot be processed. Please WhatsApp our Customer Care at +65 6887 8777.",
        });
      }
      this.setState({ registrationAction: false });
    }
    
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onChangeNRIC = (event) => {
  
    this.setState({ nric: event.target.value.toUpperCase() });
  };

  onClickNext = () => {
 
    const { registrationRequest } = this.props;
    registrationRequest(this.state.nric);
    this.setState({ registrationAction: true });
  };

  onClickContactUs = () => {

    // window.location = "http://yoursite.com/page?variable=1";
  };

  onClickBack = () => {
    const { history } = this.props;
    //history.push("/prototype/");
    window.location.href = process.env.REACT_APP_LOGIN_BASE_URL;
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };

  handleKeypress = (event) => {
    //it triggers by pressing the enter key
    if (event.keyCode === 13) {
      this.onClickNext();
    }
  };

  render() {
    const { classes,registrationReqLoading } = this.props;
    const { height, nric } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard
          children={
            <ActivateAccount
              nric={nric}
              onChangeNRIC={this.onChangeNRIC}
              onClickNext={this.onClickNext}
              onClickContactUs={this.onClickContactUs}
              onClickBack={this.onClickBack}
              handleKeypress={this.handleKeypress}
            />
          }
          height={height}
        />
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
          {registrationReqLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
});

function mapStateToProps(state) {
  return {
    registrationReqData: selector.registrationReqData(state),
    registrationReqLoading: selector.registrationReqLoading(state),
    registrationReqStatus: selector.registrationReqStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    registrationRequest: (nric) =>
      dispatch(registrationAction.registrationRequest(nric)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(Registration)));
